import React, { ReactNode } from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";

interface PageShellProps {
  title: string;
  description?: string;
  wide?: boolean;
  fluid?: boolean;
  actions?: ReactNode;
  children: ReactNode;
}

const PageShell: React.FC<PageShellProps> = ({
  title,
  description,
  wide = false,
  fluid = false,
  actions,
  children,
}) => {
  return (
    <Box px={{ base: 4, md: 6 }} py={8}>
      <Box maxW={fluid ? "none" : wide ? "1200px" : "880px"} mx="auto">
        <Flex justify="space-between" align="flex-start" gap={4} mb={6} wrap="wrap">
          <Box minW={0}>
            <Heading size="lg" fontWeight="600" letterSpacing="-0.02em">
              {title}
            </Heading>
            {description ? (
              <Text mt={1} fontSize="sm" color="gray.600">
                {description}
              </Text>
            ) : null}
          </Box>
          {actions}
        </Flex>
        {children}
      </Box>
    </Box>
  );
};

export default PageShell;
